/* eslint-disable jsx-a11y/alt-text */
import { IconFont, SignTitle, SvgIcon, TableTag, TagDetail } from '@/components'
import { Modal, Spin, Tag } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useResultTemplateDetail, useTemplateDetail } from './utils'
import MarkdownEditor from '@/components/markdown-editor'
import { t } from '@/i18n'
interface TemplateParticularsProps {
  particulars: { visible: boolean; id: string; result_id: string }
  setParticulars: (par: { visible: boolean; id: string }) => void
  type?: number
}

export interface V1TagCategory {
  tagCategoryName?: string
  tagName?: string[]
  [property: string]: any
}
interface DetailProps {
  origin_type: number
  name: string
  format_name: string
  describe: string
  content: string
  file_type: number
  variable_list: string[]
  file_name: string
  resource_tag_list?: V1TagCategory[]
}
export const TemplateParticulars = (props: TemplateParticularsProps) => {
  const { particulars, setParticulars, type } = props
  const [detail, setDetail] = useState<DetailProps>({})
  const [getResultDetail] = useResultTemplateDetail()
  const [getDetail] = useTemplateDetail()
  const [detailLoading, setDetailLoading] = useState(false)
  useEffect(() => {
    if (particulars.visible && particulars.id) {
      setDetailLoading(true)
      if (type === 1) {
        getResultDetail({ task_id: particulars.id, result_id: particulars.result_id })
          .then(res => {
            setDetail(res.data)
          })
          .catch(_ => {})
          .finally(() => {
            setDetailLoading(false)
          })
      } else {
        getDetail({ id: particulars.id })
          .then(res => {
            setDetail(res.data)
          })
          .catch(_ => {})
          .finally(() => {
            setDetailLoading(false)
          })
      }
    }
  }, [particulars.id, particulars.task_id])
  return (
    <TaskTemplate
      visible={particulars.visible}
      centered
      title={<SignTitle show>{t('模板详情')}</SignTitle>}
      footer={false}
      width={700}
      onOk={() => {}}
      onCancel={() => {
        setParticulars({ visible: false, id: null })
        setDetail({})
      }}
    >
      {detailLoading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Spin />
        </div>
      ) : (
        <div>
          <div className="flex">
            {detail?.origin_type === 1 ? (
              <TableTag background="#558492" color="#fff" style={{ padding: '3px 4px' }}>
                {t('系统内置')}
              </TableTag>
            ) : (
              <TableTag background="#ED787E" color="#fff" style={{ padding: '3px 4px' }}>
                {t('自定义')}
              </TableTag>
            )}
            <div className="headline">{detail?.name || ''}</div>
          </div>
          <div className="file-format flex">
            <div className="title">{t('文件格式：')}</div>
            <div className="text">
              <div className="value">{detail?.format_name || ''}</div>
              {/* {detail.file_type === 3 && <div className="value">无格式</div>} */}
            </div>
          </div>
          {detail?.tactics?.length > 0 && (
            <div className="flex" style={{ marginBottom: '24px', justifyContent: 'flex-start' }}>
              <span className="title" style={{ width: '115px' }}>
                ATT&CK：
              </span>
              <div style={{ width: '295px' }}>
                {detail?.tactics?.map(item => (
                  <div key={item.id} style={{ marginBottom: '6px' }}>
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* 用例标签 */}
          {detail?.resource_tag_list && detail?.resource_tag_list?.length > 0 && (
            <TagDetail resourceTagList={detail?.resource_tag_list} />
          )}
          <div style={{ marginBottom: 16 }}>
            <div className="title" style={{ marginBottom: 16 }}>
              {t('描述：')}
            </div>
            <MarkdownEditor
              isEdit={false}
              onlyDisplay
              setValue={() => {}}
              value={detail?.describe || ''}
            />
          </div>

          {detail?.file_type === 4 ? (
            <div>
              <div className="title" style={{ marginBottom: 16 }}>
                {t('数据内容：')}
              </div>
              <div className="flex">
                <IconFont type="icon-047-file" />
                <div style={{ marginLeft: 12 }}>{detail?.file_name || ''}</div>
              </div>
            </div>
          ) : (
            <div className="flex">
              <div style={{ flex: 1 }}>
                <div className="title">{t('数据内容：')}</div>
                <div className="data-content">
                  <div>{detail?.content || ''}</div>
                </div>
              </div>
              <div style={{ marginLeft: 10, flex: 1 }}>
                <div className="title">{t('动态生成数据的变量：')}</div>
                <div className="data-content">
                  {detail?.variable_list?.length
                    ? detail?.variable_list?.map((item, index) => <div key={index}>{item}</div>)
                    : '-'}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </TaskTemplate>
  )
}
const TaskTemplate = styled(Modal)`
  .ant-modal-body {
    height: 605px;
    overflow-y: scroll;
  }
  .flex {
    display: flex;
    align-items: center;
    .headline {
      font-weight: bold;
      margin-left: 4px;
    }
  }
  .file-format {
    margin: 21px 0 24px 0;
  }
  .title {
    color: #666;
  }
  .describe {
    height: 126px;
    background: #f8f9fb;
    border-radius: 8px;
    margin-top: 12px;
    padding: 14px;
    overflow-y: scroll;
    overflow-x: hidden;
    word-wrap: break-word;
    word-break: break-all;
    margin-bottom: 24px;
  }
  .data-content {
    margin-top: 12px;
    width: 305px;
    height: 261px;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 14px;
    overflow-y: scroll;
    overflow-x: hidden;
    word-wrap: break-word;
    line-height: 20px;
  }
`
